import { Container, Row } from 'reactstrap';
import TryoutDetail from './TryoutDetail';

const DetailTryout = () => {

  return (
    <>
      <Container fluid={true}>
        <Row className='learning-block'>
          <TryoutDetail />
        </Row>
      </Container>
    </>
  );
};

export default DetailTryout;